import { Box, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../styles/offer.styles";
import ActiveContext from "../../../Context/Context";
import {
  isWhiteFridayActive,
  WHITE_FRIDAY_AMOUNT,
  WHITE_FRIDAY_COUNTRIES,
} from "../utils/offer.constants";

function Offer() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { clinicData } = useContext(ActiveContext);
  const clinicInfo = clinicData?.data?.clinic_info;
  const country = clinicInfo?.country;

  if (WHITE_FRIDAY_COUNTRIES.includes(country) && isWhiteFridayActive()) {
    const beforeKey = country === "LB" ? "black-friday-offer-before" : "white-friday-offer-before";

    return (
      <Box className={classes.offerContainer}>
        <Typography className={classes.offerText}>
          {t(beforeKey)}
          {WHITE_FRIDAY_AMOUNT[country]}
          {t("friday-offer-after")}
        </Typography>
      </Box>
    );
  }

  return null;
}

export default Offer;
